import { render, staticRenderFns } from "./RELAcessoQrCode.vue?vue&type=template&id=b95fb4ca&"
import script from "./RELAcessoQrCode.vue?vue&type=script&lang=js&"
export * from "./RELAcessoQrCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports